import { theme } from "../../../../../../../../theme";

export default function BTeileBarSVG(props) {
  const fontFamily = theme.typography.fontFamily;
  return (
    <svg
      {...props}
      viewBox="0 0 389 907"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="BTeileBarSVG Kopie 2">
        <text
          className="gsap-bar-label"
          fill="black"
          xmlSpace="preserve"
          style="white-space: pre"
          fontFamily={fontFamily}
          fontSize="73"
        >
          <tspan x="113.266" y="701.28">
            15 %
          </tspan>
        </text>
        <rect
          className="gsap-bar"
          y="757"
          width="389"
          height="150"
          fill="#E20031"
        />
      </g>
    </svg>
  );
}
